import BaseService from './base.service';

export default class CreatorService extends BaseService {
  async inviteCreator(name, phoneNumber, email, isTrainee) {
    await this.post('/creators', { email, isTrainee, name, phoneNumber });
  }

  async resendInvite(name, phoneNumber, email, id) {
    await this.put(`/creators/resend-invitation/${id}`, { email, name, phoneNumber });
  }

  async getCreators(criteria) {
    const queryString = this.getQueryString(criteria);
    return this.get(`/creators${queryString}`);
  }
}
